import useSWR from 'swr'
import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import CampaignService from '@forwardflow/services/CampaignService'

export function usePrompts() {
   const { data, error, isLoading, mutate } = useSWR(
      [QUERY_KEYS.PROMPTS],
      () => CampaignService.getPrompts(),
      {
         revalidateOnFocus: false,
         dedupingInterval: 5 * 60 * 1000,
      }
   )

   const conversationalAiPrompt = Array.isArray(data)
      ? data.find(
           (prompt: any) =>
              prompt?.type?.toLowerCase?.().trim() === 'conversational-ai'
        )
      : undefined

   return {
      prompts: data,
      conversationalAiPrompt,
      isLoading,
      error,
      mutate,
   }
}
